module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Space Gray Aluminum + Black Volt Nike Open.a4e8a521.png";